export const SpaceService = Symbol.for('SpaceService');
